<h1 class="text-white text-left">
  Routinen Anpassungen
</h1>
<p class="font-weight-bolder text-white text-left">
  Du kannst Punkte entfernen, neue hinzufügen und die Häufigkeit anpassen. Sie werden zum Beginn deiner nächsten 28 Tage angepasst.<br />
</p>
<p class="font-weight-bolder text-white text-left">
  Dein nächster Turnus beginnt <%= routinePlan.momentBeginnUtc.fromNow() %>.
</p>

<h2 class="text-white text-left text-uppercase">
  Morgenroutine
</h2>
<% let routines = routinePlan.getDailyMorningRoutines() %>
<% if ( routines.length > 0 ) { %>
  <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
    <routine-selection-edit name="<%= routines[ ri ].name %>"
                            routine-id="<%= routines[ ri ].id %>"
                            category-id="<%= routines[ ri ].categoryId %>"
                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                            goal="<%= routines[ ri ].goal %>"
                            icon="<%= routines[ ri ].icon %>"></routine-selection-edit>
  <% }  %>
<% } else { %>
  <p class="text-white font-weight-bolder">--- keine ausgewählt ---</p>
<% }  %>

<h2 class="text-white text-left text-uppercase mt-4">
  Mittagsroutine
</h2>
<% routines = routinePlan.getDailyMiddayRoutines() %>
<% if ( routines.length > 0 ) { %>
  <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
    <routine-selection-edit name="<%= routines[ ri ].name %>"
                            routine-id="<%= routines[ ri ].id %>"
                            category-id="<%= routines[ ri ].categoryId %>"
                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                            goal="<%= routines[ ri ].goal %>"
                            icon="<%= routines[ ri ].icon %>"></routine-selection-edit>
  <% }  %>
<% } else { %>
  <p class="text-white font-weight-bolder">--- keine ausgewählt ---</p>
<% }  %>

<h2 class="text-white text-left text-uppercase mt-4">
  Abendroutine
</h2>
<% routines = routinePlan.getDailyEveningRoutines() %>
<% if ( routines.length > 0 ) { %>
  <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
    <routine-selection-edit name="<%= routines[ ri ].name %>"
                            routine-id="<%= routines[ ri ].id %>"
                            category-id="<%= routines[ ri ].categoryId %>"
                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                            goal="<%= routines[ ri ].goal %>"
                            icon="<%= routines[ ri ].icon %>"></routine-selection-edit>
  <% }  %>
<% } else { %>
  <p class="text-white font-weight-bolder">--- keine ausgewählt ---</p>
<% }  %>

<h2 class="text-white text-left text-uppercase mt-4">
  Tagesziele
</h2>
<% routines = routinePlan.getDailyGoalRoutines() %>
<% if ( routines.length > 0 ) { %>
  <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
    <routine-selection-edit name="<%= routines[ ri ].name %>"
                            routine-id="<%= routines[ ri ].id %>"
                            category-id="<%= routines[ ri ].categoryId %>"
                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                            goal="<%= routines[ ri ].goal %>"
                            icon="<%= routines[ ri ].icon %>"></routine-selection-edit>
  <% }  %>
<% } else { %>
  <p class="text-white font-weight-bolder">--- keine ausgewählt ---</p>
<% }  %>

<h2 class="text-white text-left text-uppercase mt-4">
  Wochenziele
</h2>
<% routines = routinePlan.getWeeklySportGoalRoutines() %>
<% routines = routines.concat( routinePlan.getWeeklyConsumeGoalRoutines() ) %>
<% routines = routines.concat( routinePlan.getWeeklySpiritGoalRoutines() ) %>
<% routines = routines.concat( routinePlan.getWeeklyGoalRoutines() ) %>
<% if ( routines.length > 0 ) { %>
  <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
    <routine-selection-edit name="<%= routines[ ri ].name %>"
                            routine-id="<%= routines[ ri ].id %>"
                            category-id="<%= routines[ ri ].categoryId %>"
                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                            goal="<%= routines[ ri ].goal %>"
                            icon="<%= routines[ ri ].icon %>"></routine-selection-edit>
  <% }  %>
<% } else { %>
  <p class="text-white font-weight-bolder">--- keine ausgewählt ---</p>
<% }  %>
